import React, {Fragment} from 'react';
import Image from '../Image';
import {currentLang, farmerURL} from '../../../utils/functions';
import {uniqueId} from 'lodash';
import { useTranslation } from 'react-i18next';

const FarmerItem = ({data, type, animal}) => {
    const { t } = useTranslation();
    //const url = "/"+currentLang()+"/"+t("menu.farmers")+"/"+data.slug+(data.slug == t("farmers.newfarmerslug") ? "/"+animal : "");
    const url = farmerURL(data.slug+(data.slug == t("farmers.newfarmerslug") ? "/"+animal : ""));
    return (
        <div className="list__item" key={uniqueId('farmerItem_')}>
            <div className="list__body">
                <div className="list__image">
                    <a className="read-more text--primary" href={url}><Image src={data.image_url} /></a>
                    {data.location &&
                    <div className="list__info">
                        <div className="badge">
                            <div className="badge__item location"> <span className="icon-location"></span> {data.location} </div>
                        </div>
                    </div>
                    }
                    <div className="list__badges">
                        {data.quality_levels && data.quality_levels.includes('premium') &&
                            <div className="badge badge--premium">
                                Premium
                            </div>
                        }
                        {data.is_organic == 1 &&
                            <div className="badge badge--bio">
                                Bio
                            </div>
                        }
                        {data.is_msc == 1 && 
                            <div className="badge badge--msc">
                                MSC
                            </div>
                        
                        }
                    </div>
                </div>
                <div className="list__description">
                    <div>
                        <h3 className="title"> <a className="text--white" href={url}>{data.title}</a> </h3>
                        <div className="excerpt text--white">{data.summary}</div>
                    </div>

                    <a className="read-more" href={url}>

                        {['game', 'roe', 'deer', 'boar'].includes(type) &&
                            <Fragment>
                            {t("farmers.readmoreaboutfarmer_deer")}
                            </Fragment>
                        }
                        {['fish', 'salmon'].includes(type) &&
                            <Fragment>
                            {t("farmers.readmoreaboutfarmer_fish")}
                            </Fragment>
                        }
                        {!['game', 'roe', 'deer', 'boar', 'fish', 'salmon'].includes(type) &&
                            <Fragment>
                                {t("farmers.readmoreaboutfarmer")}
                            </Fragment>
                        }
                        </a>
                </div>
            </div>
        </div>
    )
}

export default FarmerItem
